import { createFileRoute } from '@tanstack/react-router';
import CollateralClauses from '../../../features/baseData/collateralClauses/collateralClauses';
import {
  COLLATERAL_CLAUSES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/nebenbestimmungen/')({
  component: CollateralClauses,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COLLATERAL_CLAUSES_PERMISSIONS, 'READ'),
  ),
});

export const ListCollateralClauseRoute = Route;
